import instance from '../instance'
export default class Vendors {
  static getUser() {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      method: 'GET'
    })
  }
}
